import { useContext, useMemo } from 'react'
import { Modal, ModalOverlay, ModalContent, ModalHeader, ModalBody, ModalCloseButton, Box, Icon } from "@chakra-ui/react"
import { Text, Image, Button, Input, Flex, Avatar, Heading, IconButton } from '@chakra-ui/react'
import { Card, CardBody, CardHeader, CardFooter } from '@chakra-ui/react'
import { HandThumbUpIcon, ChatBubbleLeftEllipsisIcon, ArrowUturnLeftIcon, EllipsisHorizontalIcon, GlobeEuropeAfricaIcon } from '@heroicons/react/20/solid'

import { AdsContext } from '../../store/ads'
// <Icon as={GlobeEuropeAfricaIcon}/>

const VariationPreviewModal = ({ isOpen, onClose }) => {
	const { state: adsState, dispatch: adsDispatch } = useContext(AdsContext)

	const variation = useMemo(()=> {
		if (!adsState.campaign || adsState.selectedVariation === undefined) {
			return
		}
		return adsState.campaign.variations[adsState.selectedVariation]
	}, [adsState.campaign, adsState.selectedVariation])

	return (
		<Modal closeOnOverlayClick={false} size={"xl"} isOpen={isOpen} onClose={() => { adsDispatch({ type: "SET_SELECTED_VARIATION", value: null }); onClose() }} isCentered>
			<ModalOverlay />
			<ModalContent>
				<ModalHeader>Preview Variation</ModalHeader>
				<ModalCloseButton />
				<ModalBody>
					<Card margin="20px">
						<CardHeader>
							<Flex spacing='4'>
								<Flex flex='1' gap='4' alignItems='center' flexWrap='wrap'>
									<Avatar name='David Ogilvy' src='https://www.zerobounce.net/blog/wp-content/uploads/2018/02/david-ogilvy.jpg' />
									<Box>
										<Heading size='sm'>David Ogilvy</Heading>
										<Flex alignItems='center'>
											<Text color="blackAlpha.500">Sponsored</Text>
											<Icon ml="2px" color="blackAlpha.500" as={GlobeEuropeAfricaIcon}/>
										</Flex>
									</Box>
								</Flex>
								<IconButton variant='ghost' colorScheme='gray' aria-label='See menu' icon={<Icon as={EllipsisHorizontalIcon} />} />
							</Flex>
						</CardHeader>
						<CardBody>
							<Text>
								{variation?.description}
							</Text>
						</CardBody>
						<Image objectFit='cover' src={variation?.image} alt='Post Image'/>
						<CardFooter justify='space-between'>
							<Button flex='1' variant='ghost' leftIcon={<Icon as={HandThumbUpIcon} />}>
								Like
							</Button>
							<Button flex='1' variant='ghost' leftIcon={<Icon as={ChatBubbleLeftEllipsisIcon} />}>
								Comment
							</Button>
							<Button flex='1' variant='ghost' leftIcon={<Icon as={ArrowUturnLeftIcon}/>}>
								Share
							</Button>
						</CardFooter>
					</Card>
				</ModalBody>
			</ModalContent>
		</Modal>
	)
}
export default VariationPreviewModal